.contentLink {
    color: white;
}

.circleIcon {
    margin-top: 0.5rem;
    margin-left: 0.5rem;
}

.panel {
    margin-top: 10px;
}

.sectionTitle {
    font-weight: 600;
    color: var(--mantine-color-dark-1);
}
